
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/checkout/shipping",
      function () {
        return require("private-next-pages/shop/checkout/shipping.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/checkout/shipping"])
      });
    }
  